import { GetStaticProps } from 'next';
import React from 'react';
import { getStaticPropsHotels } from '@layout/get-page-props';
import { withGlobalProvider } from 'providers/globalProvider';
import { storeWrapper } from '@state/store';
import { ContentApi } from '@model/iceberg/service/content';
import { getHotelsStaticPaths } from '@util/get-destination-static-paths';
import { HotelsPageLayout, HotelsPageLayoutProps } from '@layout/HotelsPageLayout/HotelsPageLayout';
import { useI18NextContext } from '@components/hooks';
import { PageTemplates } from '@model/content';
import { Revalidate } from '@model/config/revalidate';

const RegionFromPricesPage = (props: HotelsPageLayoutProps) => {
  const { display } = props;
  const t: any = useI18NextContext();
  const metaTitle: string = t('seo__destination-listing-page--title', {
    destination: display
  });
  const metaDescription: string = t('seo__destination-listing-page--description', {
    destination: display
  });

  return <HotelsPageLayout {...props} metaTitle={metaTitle} metaDescription={metaDescription} />;
};

export const getStaticProps: GetStaticProps = storeWrapper.getStaticProps((store) => async (props: any) => ({
  ...(await getStaticPropsHotels(store, props)),
  revalidate: Revalidate.HALF_HOUR
}));

export async function getStaticPaths() {
  const destinationPages = await new ContentApi().getPageConfigMap({ template: PageTemplates.DESTINATION });

  const paths = getHotelsStaticPaths(destinationPages);
  if (!paths.length) {
    throw Error('No paths on page /destination/[continent]/[country]/[region]/hotels');
  }

  return { paths, fallback: false };
}

export default withGlobalProvider(RegionFromPricesPage);
